import React from 'react';
import PropTypes from 'prop-types';
import {apiRequest} from '../../utils/request';
import {toastr} from 'react-redux-toastr';
import { Button, Input, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Run from '../Runs/Run';
import {
  runLocationCheckIn, loadRun, saveRun, deleteRun, saveRunReorder,
  runLocationCompletePickup
} from '../../actions/runActions';

class RunModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      runId: props.runId ? props.runId : 0,
      run: {},
      isOpen: false,
      isMapView: false,
      isListView: true,
      locationId: props.locationId ? props.locationId : 0,
    };
    this.loadRun = this.loadRun.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
  }

  loadRun(runId, locationId){
    this.setState({run: {}, runId, isOpen: true, isMapView: false, isListView: true, locationId});
    return apiRequest(`/api/runs/${runId}?hideSmsNoResponse=${!this.props.showLocationsWithNotes ? true : false}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching runId: ${runId} error: ${x.error ? x.error : x.data.Message}`);
        } else {
          this.setState({run: {...x.data}, isOpen: true});
        }
      });
  }

  toggleOpen(){
    let isOpen = !this.state.isOpen;
    this.setState({isOpen, runId: -1});
    if(!isOpen){
      this.props.onClosing();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let {runId, locationId} = this.props;

    if (runId !== this.state.runId && runId > 0) {
      this.loadRun(runId, locationId).then(() => {
      });
    }
  }

  render() {
    return (<div>
      <Modal isOpen={this.state.isOpen} toggle={this.toggleOpen}>
        <ModalBody>
          {!this.state.run.id && <div>Loading <i className="fa fa-cog fa-spin" /></div>}

          <Run run={this.state.run}
               onLocationCheckin={(runId, pickupId, status) => this.props.dispatch(runLocationCheckIn(runId, pickupId, status))}
               onRunRefresh={()=> this.loadRun(this.state.runId, this.state.locationId)}
               showLink={false}
               isMapView={this.state.isMapView}
               isListView={this.state.isListView}
               scrollToLocationId={this.state.locationId}
               onSaveRun={(run) => this.props.dispatch(saveRun(run, this.state.run))}
               isAdmin={this.props.account && this.props.account.user && this.props.account.user.hasRole("SuperUser")}
               onLoadDriverLocations={()=>this.props.dispatch(loadRun(this.state.run.id, null, null, true))}
               showEdit={false}
               onDeleteRun={(runId) => this.props.dispatch(deleteRun(runId))}
               onSaveReorderRun={(run)=>this.props.dispatch(saveRunReorder(run, this.state.run))}
               showPickupImages={this.props.showPickupImages}
               onCompletePickup={(pickup, isCancel) => this.props.dispatch(runLocationCompletePickup(pickup, isCancel))}
               showLocationsWithNotes={this.props.showLocationsWithNotes}
               locationId={this.state.locationId}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.toggleOpen}>Close</Button>
        </ModalFooter>
      </Modal>

    </div>);
  }
}

RunModal.propTypes = {
  runId: PropTypes.number.isRequired,
  onClosing: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  account: PropTypes.object.isRequired,
  locationId: PropTypes.number,
  showPickupImages: PropTypes.bool.isRequired,
};

RunModal.defaultProps = {
  showPickupImages: true,
};

export default RunModal;